export const GET_BOOK_NOW_BUTTON_CONFIGS_START = 'GET_BOOK_NOW_BUTTON_CONFIGS_START';
export const GET_BOOK_NOW_BUTTON_CONFIGS_SUCCESS = 'GET_BOOK_NOW_BUTTON_CONFIGS_SUCCESS';
export const GET_BOOK_NOW_BUTTON_CONFIGS_FAILED = 'GET_BOOK_BUTTON_CONFIGS_FAILED';

export const SAVE_BOOK_NOW_BUTTON_CONFIGS_START = 'SAVE_BOOK_NOW_BUTTON_CONFIGS_START';
export const SAVE_BOOK_NOW_BUTTON_CONFIGS_SUCCESS = 'SAVE_BOOK_NOW_BUTTON_CONFIGS_SUCCESS';
export const SAVE_BOOK_NOW_BUTTON_CONFIGS_FAILED = 'SAVE_BOOK_NOW_BUTTON_CONFIGS_FAILED';

export const GET_APPOINTMENT_BUTTON_CONFIGS_START = 'GET_APPOINTMENT_BUTTON_CONFIGS_START';
export const GET_APPOINTMENT_BUTTON_CONFIGS_SUCCESS = 'GET_APPOINTMENT_BUTTON_CONFIGS_SUCCESS';
export const GET_APPOINTMENT_BUTTON_CONFIGS_FAILED = 'GET_APPOINTMENT_BUTTON_CONFIGS_FAILED';

export const SAVE_APPOINTMENT_BUTTON_CONFIGS_START = 'SAVE_APPOINTMENT_BUTTON_CONFIGS_START';
export const SAVE_APPOINTMENT_BUTTON_CONFIGS_SUCCESS = 'SAVE_APPOINTMENT_BUTTON_CONFIGS_SUCCESS';
export const SAVE_APPOINTMENT_BUTTON_CONFIGS_FAILED = 'SAVE_APPOINTMENT_BUTTON_CONFIGS_FAILED';

export const getBookNowButtonConfigsStart = () => ({
  type: GET_BOOK_NOW_BUTTON_CONFIGS_START,
});

export const getBookNowButtonConfigsSuccess = (data) => ({
  type: GET_BOOK_NOW_BUTTON_CONFIGS_SUCCESS,
  data
});

export const getBookNowButtonConfigFailed = (error) => ({
  type: GET_BOOK_NOW_BUTTON_CONFIGS_FAILED,
  error
});

export const saveBookNowButtonConfigStart = () => ({
  type: SAVE_BOOK_NOW_BUTTON_CONFIGS_START
});

export const saveBookNowButtonConfigSuccess = (data) => ({
  type: SAVE_BOOK_NOW_BUTTON_CONFIGS_SUCCESS,
  data
});

export const saveBookNowButtonConfigFailed = (error) => ({
  type: SAVE_BOOK_NOW_BUTTON_CONFIGS_FAILED,
  error
});

export const getAppointmentButtonConfigsStart = () => ({
  type: GET_APPOINTMENT_BUTTON_CONFIGS_START
});

export const getAppointmentButtonConfigsSuccess = (data) => ({
  type: GET_APPOINTMENT_BUTTON_CONFIGS_SUCCESS,
  data
});

export const getAppointmentButtonConfigsFailed = (error) => ({
  type: GET_APPOINTMENT_BUTTON_CONFIGS_FAILED,
  error
});

export const saveAppointmentButtonConfigsStart = () => ({
  type: SAVE_APPOINTMENT_BUTTON_CONFIGS_START
});

export const saveAppointmentButtonConfigsSuccess = (data) => ({
  type: SAVE_APPOINTMENT_BUTTON_CONFIGS_SUCCESS,
  data
});

export const saveAppointmentButtonConfigFailed = (error) => ({
  type: SAVE_APPOINTMENT_BUTTON_CONFIGS_FAILED,
  error
});
